import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';
import { SVG_COMPONENTS } from '@/assets/admin';

interface ContactRowProps {
  kind: 'phone' | 'email';
  label: string;
  value?: string;
  onPress?: () => void;
}

export const ContactRow: React.FC<ContactRowProps> = ({ kind, label, value, onPress }) => {
  const Icon = kind === 'phone' ? SVG_COMPONENTS.PHONE : SVG_COMPONENTS.EMAIL_SOLID;
  const hasValue = !!value;
  return (
    <TouchableOpacity style={styles.row} onPress={onPress} disabled={!hasValue} activeOpacity={0.7}>
      <View style={styles.iconContainer}>
        <Icon width={20} height={20} color="#FFFFFF" />
      </View>
      <View style={styles.info}>
        <Text style={styles.label}>{label}</Text>
        <Text style={styles.value}>{hasValue ? value : `No ${kind} provided`}</Text>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'center', marginBottom: 16 },
  iconContainer: {
    width: 40, height: 40, borderRadius: 20,
    backgroundColor: ADMIN_COLORS.BACKGROUND.SECONDARY,
    justifyContent: 'center', alignItems: 'center', marginRight: 12,
  },
  info: { flex: 1 },
  label: { fontSize: 11, fontWeight: '600', color: ADMIN_COLORS.TEXT_SECONDARY, marginBottom: 2, letterSpacing: 0.5 },
  value: { fontSize: 14, color: ADMIN_COLORS.TEXT_PRIMARY },
});


